// extracted by mini-css-extract-plugin
export var container = "cookiesAlert-module--container--YxWHG";
export var content = "cookiesAlert-module--content--M62KE";
export var opcionesYBoton = "cookiesAlert-module--opcionesYBoton--UfwQD";
export var texto = "cookiesAlert-module--texto--lFfsb";